<template>
    <section class="code-sample" v-if="code && factory">
        <code-block :language="language" :code="code"/>
    </section>
</template>

<script>
  import CodeSampleFactory from '../modules/CodeSampleFactory';
  import Endpoint          from '../modules/Elements/Endpoint';
  import CodeBlock         from './CodeBlock';

  export default {
    name: 'CodeSample',

    components: {
      CodeBlock,
    },

    props: {
      language: {
        type:      String,
        required:  false,
        validator: value => [ 'shell', 'javascript', 'php', 'python' ].includes(value),
      },

      endpoint: {
        type:     Endpoint,
        required: true,
      },

      parameters: {
        type:     Object,
        required: true,
      },

      indentation: {
        type:    Number,
        default: 4,
      },
    },

    data () {
      return {
        factory: null,
      };
    },

    computed: {
      code () {
        if ( !this.language ) {
          return '';
        }

        return this.buildSample(this.language, this.endpoint, this.parameters);
      },
    },

    mounted () {
      this.factory = new CodeSampleFactory(this.endpoint, this.indentation);
    },

    methods: {
      buildSample ( language, endpoint, parameters ) {
        const token = this.$auth.token || '%token%';

        return this.factory.buildSample(language, parameters, token);
      },
    },
  };
</script>

<style scoped>

</style>
